import { useState } from "react";

const P = {
  bg:"#080B14", card:"#0D1020", border:"#1D2238",
  gold:"#E9622A", text:"#EBE8F5", muted:"#8A8EAE", secondary:"#B4B7D0",
  green:"#5BB87A", red:"#C46B6B", blue:"#5A82B8",
};

const NICOL_TARIFFA = 12.50;
const GDS = ["Dom","Lun","Mar","Mer","Gio","Ven","Sab"];
const NOMI_MESI_IT = ["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"];

// Genera mesi da settembre 2025 fino al mese corrente + 12 mesi avanti
function getMesiDisponibili() {
  const start = { anno: 2025, mese: 8 }; // settembre 2025 (0-indexed)
  const oggi = new Date();
  const fine = { anno: oggi.getFullYear(), mese: oggi.getMonth() + 12 };
  const lista = [];
  let { anno, mese } = start;
  while (anno < fine.anno || (anno === fine.anno && mese <= fine.mese)) {
    lista.push(`${NOMI_MESI_IT[mese]}-${anno}`);
    mese++;
    if (mese > 11) { mese = 0; anno++; }
  }
  return lista;
}

function getMeseCorrente() {
  const oggi = new Date();
  return `${NOMI_MESI_IT[oggi.getMonth()]}-${oggi.getFullYear()}`;
}

export default function Segreteria({
  nicolPresenze, setNicolPresenze,
  nicolMesi, setNicolMesi,
  isMobile, toggleStipendioConCassa,
  segreteriaNome, onSaveNome,
  onSavePresenza, onSavePagato,
}) {
  const MESI_DISPONIBILI = getMesiDisponibili();
  const [meseSel, setMeseSel] = useState(getMeseCorrente);
  const [editingNome, setEditingNome] = useState(false);
  const [nomeTemp, setNomeTemp] = useState('');

  const meseIdx = MESI_DISPONIBILI.indexOf(meseSel);
  const [nomeMese, annoStr] = meseSel.split('-');
  const anno = parseInt(annoStr, 10);
  const mIdxCal = NOMI_MESI_IT.indexOf(nomeMese);
  const nGiorni = new Date(anno, mIdxCal + 1, 0).getDate();
  const primoGiorno = new Date(anno, mIdxCal, 1).getDay();
  const meseLabelCap = nomeMese.charAt(0).toUpperCase() + nomeMese.slice(1);

  // Presenze del mese selezionato
  const presMese = nicolPresenze[meseSel] || {};
  const oreMese = Object.values(presMese).filter(Boolean).length;
  const stipendioMese = Math.round(oreMese * NICOL_TARIFFA * 100) / 100;
  const pagato = !!(nicolMesi[meseSel]?.pagato);

  // Totali anno
  const totOre = MESI_DISPONIBILI.reduce((s, m) =>
    s + Object.values(nicolPresenze[m] || {}).filter(Boolean).length, 0);
  const totPagato = MESI_DISPONIBILI.reduce((s, m) => {
    if (!nicolMesi[m]?.pagato) return s;
    const ore = Object.values(nicolPresenze[m] || {}).filter(Boolean).length;
    return s + Math.round(ore * NICOL_TARIFFA * 100) / 100;
  }, 0);
  const totDovuto = MESI_DISPONIBILI.reduce((s, m) => {
    if (nicolMesi[m]?.pagato) return s;
    const ore = Object.values(nicolPresenze[m] || {}).filter(Boolean).length;
    return s + Math.round(ore * NICOL_TARIFFA * 100) / 100;
  }, 0);

  // Calendario
  const cells = [];
  for (let i = 0; i < primoGiorno; i++) cells.push(null);
  for (let d = 1; d <= nGiorni; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);
  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const oggi = new Date();
  const isOggi = (d) => anno === oggi.getFullYear() && mIdxCal === oggi.getMonth() && d === oggi.getDate();

  const togglePresenza = (d) => {
    const presente = !!presMese[d];
    const nuovoPresente = !presente;
    setNicolPresenze(prev => {
      const cur = prev[meseSel] || {};
      const next = { ...cur };
      if (next[d]) delete next[d]; else next[d] = true;
      return { ...prev, [meseSel]: next };
    });
    onSavePresenza(meseSel, d, nuovoPresente);
  };

  const togglePagato = () => {
    const nuovoPagato = !pagato;
    toggleStipendioConCassa(`SEGRETERIA · ${meseLabelCap}`, stipendioMese, meseSel);
    setNicolMesi(prev => ({ ...prev, [meseSel]: { pagato: nuovoPagato } }));
    onSavePagato(meseSel, nuovoPagato);
  };

  return (
    <div style={{animation:"fi .35s ease"}}>
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:24,flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{fontSize:11,letterSpacing:3,color:"#4f83cc",marginBottom:7,fontWeight:600}}>SEGRETERIA</div>
          {editingNome ? (
            <input
              autoFocus
              value={nomeTemp}
              onChange={e=>setNomeTemp(e.target.value)}
              onBlur={()=>{ if(nomeTemp.trim()) onSaveNome(nomeTemp.trim()); setEditingNome(false); }}
              onKeyDown={e=>{ if(e.key==='Enter'){ if(nomeTemp.trim()) onSaveNome(nomeTemp.trim()); setEditingNome(false); } if(e.key==='Escape') setEditingNome(false); }}
              style={{fontFamily:"'Syne',sans-serif",fontSize:isMobile?22:32,fontWeight:800,letterSpacing:-0.5,
                background:"transparent",border:"none",borderBottom:`2px solid #4f83cc`,
                color:P.text,outline:"none",width:"100%"}}
            />
          ) : (
            <h1
              onClick={()=>{ setNomeTemp(segreteriaNome); setEditingNome(true); }}
              title="Clicca per modificare"
              style={{fontFamily:"'Syne',sans-serif",fontSize:isMobile?22:32,fontWeight:800,letterSpacing:-0.5,
                cursor:"pointer",borderBottom:`1px dashed #4f83cc55`}}>
              {segreteriaNome}
            </h1>
          )}
        </div>
        {/* Nav mese */}
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <button onClick={()=>meseIdx>0&&setMeseSel(MESI_DISPONIBILI[meseIdx-1])}
            disabled={meseIdx<=0}
            style={{background:"transparent",border:`1px solid ${P.border}`,color:meseIdx>0?P.text:P.muted,
              padding:"5px 12px",borderRadius:7,cursor:meseIdx>0?"pointer":"default",fontSize:16}}>←</button>
          <span style={{fontSize:15,fontWeight:600,color:P.text,minWidth:110,textAlign:"center"}}>
            {meseLabelCap} {anno}
          </span>
          <button onClick={()=>setMeseSel(MESI_DISPONIBILI[meseIdx+1])}
            style={{background:"transparent",border:`1px solid ${P.border}`,color:P.text,
              padding:"5px 12px",borderRadius:7,cursor:"pointer",fontSize:16}}>→</button>
        </div>
      </div>

      {/* Calendario */}
      <div style={{background:P.card,border:`2px solid #4f83cc55`,borderRadius:16,
        padding:isMobile?"20px 16px":"28px 32px",marginBottom:28,
        boxShadow:"0 4px 24px rgba(79,131,204,0.10)"}}>
        <div style={{display:"flex",alignItems:"baseline",justifyContent:"space-between",
          flexWrap:"wrap",gap:8,marginBottom:18}}>
          <div style={{fontFamily:"'Syne',sans-serif",fontSize:isMobile?20:26,fontWeight:700}}>
            Presenze {meseLabelCap} {anno}
          </div>
          <div style={{display:"flex",gap:16,alignItems:"center"}}>
            <span style={{fontSize:15,color:"#4f83cc",fontWeight:600}}>
              {oreMese} giorni presenti
            </span>
            <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:22,fontWeight:500,color:"#4f83cc"}}>
              €{stipendioMese}
            </span>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:isMobile?4:6,marginBottom:8}}>
          {GDS.map(g=><div key={g} style={{textAlign:"center",fontSize:12,
            color:g==="Dom"||g==="Sab"?P.red:P.muted,fontWeight:700,letterSpacing:.5}}>{g.toUpperCase()}</div>)}
        </div>
        {weeks.map((wk,wi)=>(
          <div key={wi} style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:isMobile?4:6,marginBottom:isMobile?4:6}}>
            {wk.map((d,di)=>{
              // Chiave diversa dai giorni (key={d}): con key={di} le caselle vuote si scambiavano coi giorni 1-6 e cambiando mese restavano caselle in più
              if(!d) return <div key={`vuoto-${di}`}/>;
              const presente = !!presMese[d];
              const dow = (primoGiorno + d - 1) % 7;
              const we = dow===0||dow===6;
              const oggi_ = isOggi(d);
              return (
                <div key={d}
                  onClick={()=>togglePresenza(d)}
                  title={presente?"Segna Assente":"Segna Presente"}
                  style={{
                    borderRadius:8, padding:isMobile?"8px 2px":"12px 4px", textAlign:"center",
                    cursor:"pointer", userSelect:"none",
                    background: presente ? "rgba(79,131,204,0.22)" : we ? "rgba(28,32,56,.6)" : `${P.bg}cc`,
                    border: `1px solid ${oggi_?"#E9622A":presente?"#4f83cc":"#4f83cc22"}`,
                    transition:"background .15s, border-color .15s, transform .1s",
                  }}
                  onMouseEnter={e=>{e.currentTarget.style.transform="scale(1.08)";}}
                  onMouseLeave={e=>{e.currentTarget.style.transform="scale(1)";}}
                >
                  <div style={{fontSize:isMobile?15:16,fontWeight:oggi_?800:700,
                    color:presente?"#4f83cc":oggi_?"#E9622A":we?P.red:P.muted,
                    fontFamily:"'Syne',sans-serif"}}>{d}</div>
                  <div style={{fontSize:13,color:presente?"#4f83cc":P.muted,minHeight:14,marginTop:2}}>
                    {presente?"✓":"·"}
                  </div>
                </div>
              );
            })}
          </div>
        ))}

        {/* Pulsante pagato */}
        <div style={{marginTop:20,display:"flex",justifyContent:"flex-end"}}>
          <span onClick={stipendioMese>0 ? togglePagato : undefined}
            style={{
              fontSize:14,fontWeight:600,padding:"6px 18px",borderRadius:20,
              cursor:stipendioMese>0?"pointer":"default",userSelect:"none",
              background: pagato?"rgba(74,222,128,.15)":"rgba(248,113,113,.15)",
              color: pagato?P.green:P.red,
              border:`1px solid ${pagato?P.green+"44":P.red+"44"}`,
              opacity:stipendioMese>0?1:0.4,
            }}>
            {pagato?"✓ Pagato":"Da pagare"}
          </span>
        </div>
      </div>

      {/* Riquadri sommario */}
      <div style={{display:"grid",gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)",gap:14,marginBottom:28}}>
        {[
          {l:`Stipendio ${meseLabelCap}`, v:`€${stipendioMese}`, c:"#4f83cc", sub:`${oreMese} giorni × €12,50`},
          {l:"Giorni Anno Totali",         v:`${totOre} gg`,      c:P.blue,    sub:`€${Math.round(totOre*NICOL_TARIFFA*100)/100} totale`},
          {l:"Già Pagato",                v:`€${totPagato}`,     c:P.green,   sub:"anno scolastico"},
          {l:"Da Pagare",                 v:`€${totDovuto}`,     c:P.red,     sub:"in sospeso"},
        ].map(s=>(
          <div key={s.l} style={{background:P.card,border:`1px solid ${P.border}`,borderRadius:12,
            padding:"16px 20px",borderLeft:`3px solid ${s.c}`}}>
            <div style={{fontSize:12,color:P.muted,marginBottom:4,letterSpacing:.5}}>{s.l.toUpperCase()}</div>
            <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:22,fontWeight:500,color:s.c}}>{s.v}</div>
            <div style={{fontSize:13,color:P.muted,marginTop:3}}>{s.sub}</div>
          </div>
        ))}
      </div>

      {/* Tabella riepilogo anno */}
      <div style={{background:P.card,border:`1px solid ${P.border}`,borderRadius:14,overflow:"hidden",marginBottom:24}}>
        <div style={{padding:"16px 20px",borderBottom:`1px solid ${P.border}`,
          fontFamily:"'Syne',sans-serif",fontSize:18}}>Riepilogo Anno 2025/2026</div>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{borderBottom:`1px solid ${P.border}`}}>
              {["Mese","Giorni","Stipendio","Stato"].map(h=>(
                <th key={h} style={{padding:"10px 16px",textAlign:"left",fontSize:11,
                  letterSpacing:2,color:P.muted,fontWeight:600}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {MESI_DISPONIBILI.map((m, i) => {
              const [nm] = m.split('-');
              const label = nm.charAt(0).toUpperCase() + nm.slice(1);
              const isCur = m === meseSel;
              const oreM = Object.values(nicolPresenze[m] || {}).filter(Boolean).length;
              const stipM = Math.round(oreM * NICOL_TARIFFA * 100) / 100;
              const pag = !!(nicolMesi[m]?.pagato);
              return (
                <tr key={m} onClick={()=>setMeseSel(m)} style={{
                  borderBottom:i<MESI_DISPONIBILI.length-1?`1px solid ${P.border}`:"none",
                  background:isCur?"rgba(79,131,204,0.06)":"transparent",
                  cursor:"pointer",
                }}>
                  <td style={{padding:"10px 16px",fontWeight:isCur?600:400,
                    color:isCur?"#4f83cc":P.text,fontSize:15}}>{label}</td>
                  <td style={{padding:"10px 16px"}}>
                    <span style={{fontFamily:"'Syne',sans-serif",fontSize:16,fontWeight:700,
                      color:isCur?"#4f83cc":P.text}}>{oreM}</span>
                    <span style={{fontSize:13,color:P.muted,marginLeft:4}}>gg</span>
                  </td>
                  <td style={{padding:"10px 16px"}}>
                    <span style={{fontFamily:"'Syne',sans-serif",fontSize:16,fontWeight:700,
                      color:stipM>0?"#4f83cc":P.muted}}>
                      {stipM>0?`€${stipM}`:"—"}
                    </span>
                  </td>
                  <td style={{padding:"10px 16px"}}>
                    {stipM>0 ? (
                      <span style={{
                        fontSize:13,padding:"4px 12px",borderRadius:20,fontWeight:600,
                        background:pag?"rgba(74,222,128,.15)":"rgba(248,113,113,.15)",
                        color:pag?P.green:P.red,
                        border:`1px solid ${pag?P.green+"44":P.red+"44"}`,
                      }}>
                        {pag?"✓ Pagato":"Da pagare"}
                      </span>
                    ) : <span style={{color:P.muted,fontSize:14}}>—</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
